import normalize from './normalize'
import getChangedValues from './getChangedValues'

export default {
  normalize,
  getChangedValues,
}
